import React from 'react';
import { PageSimple } from '../components/PageSimple';

export function AppNopage() {
  return (
    <PageSimple controls>
      <div className="page-simple__text">
        Page not found
      </div>
    </PageSimple>
  );
}
